export default __webpack_public_path__ + "media/images/features/ja/map-7fb40cfd0428af3186cb48b111b421f1.png";